import { AxiosClient } from '_api/AxiosClient';
import { config } from '_config';

const { ordersApiUrl } = config;

class MainApi extends AxiosClient {
  constructor(url) {
    super(url);
    this.getFileTypes = this.getFileTypes.bind(this);
    this.updateTask = this.updateTask.bind(this);
    this.createDelayedUpsell = this.createDelayedUpsell.bind(this);
    this.cancelAll = this.cancelAll.bind(this);
    this.getCredentials = this.getCredentials.bind(this);
    this.setCredentials = this.setCredentials.bind(this);
    this._mergeControllers = this._mergeControllers.bind(this);
    this._controllers = {};
  }

  _mergeControllers(controllerObj = {}) {
    this._controllers = { ...this._controllers, ...controllerObj };
  }

  cancelAll() {
    Object.values(this._controllers)
      .filter((controller) => !controller?.signal?.aborted)
      .forEach((controller) => {
        controller?.abort();
      });
    this._controllers = {};
  }

  getFileTypes({ productCode } = {}) {
    const path = `/category/products/${productCode}/file-types`;
    const controller = new AbortController();
    this._mergeControllers({ [path]: controller });
    return this.client.get(path, { params: { uploadable: true }, signal: controller.signal });
  }

  updateTask({ orderId, productId, taskId, body }) {
    const path = `/orders/${orderId}/products/${productId}/tasks/${taskId}`;
    const controller = new AbortController();
    this._mergeControllers({ [path]: controller });
    return this.client.put(path, body, { signal: controller.signal });
  }

  createDelayedUpsell({ orderId, body }) {
    const path = `/orders/${orderId}/create-delayed-upsale`;
    const controller = new AbortController();
    this._mergeControllers({ [path]: controller });
    return this.client.post(path, body, { signal: controller.signal });
  }

  getCredentials({ customerId }) {
    const path = `/customers/${customerId}/membership-credentials`;
    const controller = new AbortController();
    this._mergeControllers({ [path]: controller });
    return this.client.get(path, { signal: controller.signal });
  }

  setCredentials({ customerId, body }) {
    const path = `/customers/${customerId}/membership-credentials`;
    const controller = new AbortController();
    this._mergeControllers({ [path]: controller });
    return this.client.post(path, body, { signal: controller.signal });
  }
}

const ApiInstance = new MainApi(ordersApiUrl);

export { ApiInstance as MainApi };
